import React from "react";

const ExternalLinkIcon = () => {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity=".4" stroke="#1D1D1D" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12.5 8.979v4a1.333 1.333 0 0 1-1.333 1.333H3.833A1.333 1.333 0 0 1 2.5 12.98V5.646a1.333 1.333 0 0 1 1.333-1.334h4M10.5 2.312h4v4M7.167 9.646 14.5 2.312"/>
    </g>
</svg>
    )
}

export default ExternalLinkIcon;